import styled from 'styled-components';

export const SecitionDivideLine = () => {
  return <HorizontalLine />;
};

const HorizontalLine = styled.hr`
  width: calc(100% - 32px);

  height: 0px;
  align-self: stretch;
  stroke-width: 1px;
  stroke: #e4e4ed;
  margin-left: 16px;
`;
